export default __webpack_public_path__ + "static/media/image2.b1b34fc2.jpg";